import React,{useState} from "react";
import { Link } from "react-router-dom";

import image1 from '../assets/images/portfolio/websites/eleanorniagara.jpg'
import image2 from '../assets/images/portfolio/websites/residenteservices.jpg'
import image3 from '../assets/images/portfolio/websites/onlineshop.jpg'
import image4 from '../assets/images/portfolio/websites/linkspot.jpg'
import image5 from '../assets/images/portfolio/websites/wnymuslims.jpg'
import image6 from '../assets/images/portfolio/websites/apnadera.jpg'
import image7 from '../assets/images/portfolio/websites/olivetree.jpg'
import image8 from '../assets/images/portfolio/websites/tricktodo.jpg'
import image9 from '../assets/images/portfolio/websites/dlcsite.jpg'
import image10 from '../assets/images/portfolio/websites/yourbliss.jpg'
import image11 from '../assets/images/portfolio/websites/halalyouth.jpg'
import image12 from '../assets/images/portfolio/websites/fmpu.jpg'
import image13  from '../assets/images/portfolio/websites/primo.jpg'
import image14  from '../assets/images/portfolio/websites/easternfrontier.jpg'
import image15  from '../assets/images/portfolio/websites/fullstackzone.jpg'
import image16  from '../assets/images/portfolio/websites/edinfocom.jpg'
import image17  from '../assets/images/portfolio/websites/wnymedical.jpg'
import image18  from '../assets/images/portfolio/websites/hawkdevelops.jpg'
import image19  from '../assets/images/portfolio/websites/amecsite.jpg'
import image20  from '../assets/images/portfolio/websites/razzlaw.jpg'
import image21  from '../assets/images/portfolio/websites/zipproschoolsystem.jpg'
import image22  from '../assets/images/portfolio/websites/disabledcentre.jpg'
import image23  from '../assets/images/portfolio/websites/hclue.jpg'
import image24  from '../assets/images/portfolio/websites/sunspinmedia.jpg'
import image25 from '../assets/images/portfolio/websites/wnymuslim_76_independence_day.jpg'
import image26 from '../assets/images/portfolio/websites/wnymuslim_grand-announcement-chaand-raat.jpg'
import image27 from '../assets/images/portfolio/websites/wnymuslim_75_pakistan-independence-day.jpg'
import image28 from '../assets/images/portfolio/websites/manageyourbiz.jpg'


import NavBar from "../components/navbar";
import ContactUs from "../components/contactUs";
import Footer from "../components/footer";
import Switcher from "../components/switcher";




export default function LiveSites(){
  

    
   const data = [
    {
        id:0,
        image:image1,
        title:'The Eleanor Apartments',
        subtitle:'Luxury Apartment Rentals',
        link:'https://eleanorniagara.com/'
    },
    {
        id:1,
        image:image2,
        title:'Resident E-services',
        subtitle:'App Promotion and Digital Solutions',
        link:'https://residenteservices.com/'
    },
    {
        id:4,
        image:image5,
        title:'WnyMuslims',
        subtitle:'Non-profit Organization',
        link:'https://wnymuslims.org/'
    },
    {
        id:16,
        image:image17,
        title:'WNY MEDICAL, PC',
        subtitle:'Multispecialty Medical Services',
        link:'https://wnymedical.com/'
    },       
    {
        id:5,
        image:image6,
        title:'Apna Dera & Mister Dee’s',
        subtitle:'Restaurant | Food Ordering Sys',
        link:'https://apnadera.net/'
    },
    {
        id:6,
        image:image7,
        title:'Olive Tree Family Services',
        subtitle:'Advocacy & Support Services',
        link:'https://www.olivetreefs.org/'
    },
    {
        id:20,
        image:image21,
        title:'Zippro School Management System',
        subtitle:'Education Management Software',
        link:'https://zipproschoolsystem.com/'
    },  
    {
        id:7,
        image:image8,
        title:'Trick Todo',
        subtitle:'Digital Product Design Agency',
        link:'https://tricktodo.com/'
    },
    {
        id:8,
        image:image9,
        title:'Dawn Learning Center',
        subtitle:'STEM Education',
        link:'https://www.dlcsite.net/'
    },
    {
        id:9,
        image:image10,
        title:'YourBliss Magazine',
        subtitle:'Health & Wellness | Lifestyle',
        link:'https://yourbliss.us/'
    },
    {
        id:10,
        image:image11,
        title:'Halal Youth',
        subtitle:'Islamic Spiritual Resources',
        link:'https://halalyouth.com/'
    },
    {
        id:11,
        image:image12,
        title:'For More Perfect Union',
        subtitle:'International Community',
        link:'https://fmpu.org'    
    },
    {
        id:12,
        image:image13,
        title:'Primo',
        subtitle:'Healthcare Management Services',
        link:'https://www.primomso.com/'
    },
    {
        id:13,
        image:image14,
        title:'Eastern Frontier',
        subtitle:'Export & Import Services',
        link:'https://www.easternfrontier.net/'
    },
    {
        id:14,
        image:image15,
        title:'Full Stack Zone',
        subtitle:'Software Company',
        link:'https://fullstackzone.net/'
    },
    {
        id:15,
        image:image16,
        title:'Edinfocom',
        subtitle:'Education and Information Services',
        link:'https://www.edinfocom.com/'
    },
    {
        id:17,
        image:image18,
        title:'Hawk Development',
        subtitle:'Real Estate Development',
        link:'https://hawkdevelops.com/'
    },
    {
        id:18,
        image:image19,
        title:'AMEC SITE',
        subtitle:'American Muslim Empowerment Conference',
        link:'https://amecsite.org/'
    },
    {
        id:3,
        image:image4,
        title:'LinkSpot | Bio-Link',
        subtitle:'Social Media Tools',
        link:'https://linkspot.tricktodo.com/'
    },
    {
        id:19,
        image:image20,
        title:'Jay Razzouk, Attorney at Law',
        subtitle:'Business Law and Legal Consulting',
        link:'https://www.razzlaw.com/home'
    },
    {
        id:21,
        image:image22,
        title:'Disabled Centre',
        subtitle:'Center for Empowerment of the Disabled',
        link:'https://disabledcentre.org/'
    },
    {
        id:2,
        image:image3,
        title:'Multi-vendor Marketplace',
        subtitle:'Ecommerce SAAS',
        link:'https://onlineshop.tricktodo.com/'
    },    
    {
        id:22,
        image:image23,
        title:'Hclue',
        subtitle:'Student Services and Resources | USA',
        link:'https://hclue.com/'
    },
    {
        id:23,
        image:image24,
        title:'SunSpin Media',
        subtitle:'Design agency | New York',
        link:'https://sunspinmedia.com/'
    },
    {
        id:24,
        image:image25,
        title:'WNY Health Fair | Event',
        subtitle:'Pakistan Independence Day Parade',
        link:'https://www.wnymuslims.org/post/wnyhealthfair-pakindependenceday-parade'
    },
    {
        id:25,
        image:image26,
        title:'CHAAND RAAT | Event',
        subtitle:'Night of Moon Celebration',
        link:'https://www.wnymuslims.org/post/grand-announcement-chaand-raat/'
    },
    {
        id:26,
        image:image27,
        title:'Pakistan Independence Day | Event',
        subtitle:'Anniversary of USA Pakistan Relations',
        link:'https://www.wnymuslims.org/post/pakistan-independence-day/'
    },
    {
        id:27,
        image:image28,
        title:'Manage Your Business',
        subtitle:'Business Support & Consulting',
        link:'https://www.manageyourbiz.com/'
    },
   ]
   
    return(
        <>
        <NavBar linkReferences={null}/>
        <section className="relative table w-full py-32 lg:py-40 bg-[url('../../assets/images/portfolio/bg-inner.jpg')] bg-no-repeat bg-top bg-cover">
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/80 to-black"></div>
            <div className="container relative">
                <div className="grid grid-cols-1 pb-8 text-center mt-10">
                    <h3 className="mb-3 text-3xl leading-normal font-medium text-white"><span >Live</span> Websites</h3>

                    <ul className="list-none">
                        <li className="inline font-semibold text-white/60 me-2"> Discover fully functional websites that showcase my skillset</li>
                        
                    </ul>
                </div>
            </div>
            
            <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
                <ul className="tracking-[0.5px] mb-0 inline-block">
                   <li className="inline-block capitalize text-[14px] duration-500 ease-in-out text-white/50 hover:text-white"><Link to="/">Gohar Ali</Link></li>
                   <li className="inline-block text-[18px] text-white/50 mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right align-middle"></i></li>
                   <li className="inline-block capitalize text-[14px] duration-500 ease-in-out text-white/50 hover:text-white"><Link to="">Portfolio</Link></li>
                    <li className="inline-block text-[18px] text-white/50 mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right align-middle"></i></li>
                    <li className="inline-block capitalize text-[14px] duration-500 ease-in-out text-white" aria-current="page">Websites</li>
                </ul>
            </div>
        </section>
        <div className="relative">
            <div className="shape absolute sm:-bottom-px -bottom-[2px] start-0 end-0 overflow-hidden z-1 text-white dark:text-slate-900">
                <svg className="w-full h-auto scale-[2.0] origin-top" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>

        <div id="grid" className="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-1 gap-[30px] lg:px-6 px-4 mt-16 mb-16">
            {data.map((item,index)=>{
                return(
                <div className="picture-item" data-groups='["branding"]' key={index}>
                    <div className="group relative block overflow-hidden rounded-xl duration-500">
                        <div className="relative overflow-hidden">
                            <Link to={item.link} className="" target="new"><img src={item.image} className="rounded-xl shadow" alt=""/></Link>
                        </div>
                        <div className="content pt-3 text-center">
                            <h5 className="mb-1"><Link to={item.link} target="new" className="hover:text-orange-500 duration-500 font-semibold">{item.title}</Link></h5>
                            <h6 className="text-slate-400 dark:text-white/60">{item.subtitle}</h6>
                        </div>
                    </div>
                </div>
                )
            })}
            
        </div>
        <ContactUs/>
        <Footer/>
        <Switcher/>
        </>
    )
}